// Language translations for Customer Lookup page
// Languages: English, Arabic, Dutch, French, German, Italian, Urdu, Hindi

export const translations = {
  en: {
    code: 'en',
    name: 'English',
    flag: '🇬🇧',
    dir: 'ltr',
    backButton: 'Back',
    lockPage: 'Lock Page',
    locked: 'Locked',
    findYour: 'Find Your',
    package: 'Package',
    subtitle: 'Secure package pickup service • Professional package management for our local community',
    businessInfo: 'Ashop Local Business Package Service',
    searchInstructions: 'Search for your package using the information below',
    firstName: 'First Name',
    firstNamePlaceholder: 'Enter your first name...',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Enter your last name...',
    orDivider: 'OR',
    trackingNumber: 'Tracking Number',
    trackingPlaceholder: 'Enter tracking number...',
    requiredVerification: 'Required Contact Verification',
    requiredText: 'You MUST provide either phone number OR email address to search for packages',
    phoneNumber: 'Phone Number',
    phonePlaceholder: 'Enter 9-10 digit phone number...',
    emailAddress: 'Email Address',
    emailPlaceholder: 'Enter your email...',
    searchButton: 'Find My Package',
    searching: 'Searching Packages...',
    clearFields: 'Clear All Fields',
    trustBadges: { secure: 'Secure', instant: 'Instant', verified: 'Verified' },
    packageReady: 'Package Ready to Pick Up!',
    packageWaiting: 'Your package is waiting for you at Ashop',
    boxNumberTitle: 'Your Package is in Box Number',
    lookForBox: 'Look for the box with this number!',
    packagesFound: 'Packages Found',
    trackingNumbers: 'Tracking Numbers',
    verified: 'VERIFIED',
    scannable: 'SCANNABLE',
    scannableBarcode: 'Scannable Barcode',
    compatibleBarcode: 'Compatible Barcode',
    showBarcode: 'Show this barcode to staff for quick scanning',
    carrier: 'Carrier',
    received: 'Received',
    pickedUp: 'Picked up',
    alreadyPickedUp: 'Already Picked Up',
    confirmPickup: 'Confirm Pickup',
    note: 'Note',
    noPackagesFound: 'No packages found',
    checkSpelling: 'Please check your name spelling or try your box number',
    securityNotice: 'Security Notice',
    securityMessage: 'Please provide either your phone number (9 digits, Netherlands format) OR email address for verification before searching for packages.',
    securityHelp: 'This helps us ensure package security and prevents unauthorized access.',
    understand: 'Understand',
    informationSecure: 'Your information is secure and protected',
    enterPinToUnlock: 'Enter PIN to Unlock',
    enterPinPrompt: 'Please enter the 4-digit PIN to unlock the page',
    enterPin: 'Enter PIN',
    incorrectPin: 'Incorrect PIN. Please try again.',
    cancel: 'Cancel',
    unlock: 'Unlock',
  },
  ar: {
    code: 'ar',
    name: 'العربية',
    flag: '🇸🇦',
    dir: 'rtl',
    backButton: 'رجوع',
    lockPage: 'قفل الصفحة',
    locked: 'مقفل',
    findYour: 'ابحث عن',
    package: 'الطرد الخاص بك',
    subtitle: 'خدمة استلام الطرود الآمنة • إدارة احترافية للطرود لمجتمعنا المحلي',
    businessInfo: 'خدمة طرود أعمال Ashop المحلية',
    searchInstructions: 'ابحث عن الطرد الخاص بك باستخدام المعلومات أدناه',
    firstName: 'الاسم الأول',
    firstNamePlaceholder: 'أدخل اسمك الأول...',
    lastName: 'اسم العائلة',
    lastNamePlaceholder: 'أدخل اسم عائلتك...',
    orDivider: 'أو',
    trackingNumber: 'رقم التتبع',
    trackingPlaceholder: 'أدخل رقم التتبع...',
    requiredVerification: 'التحقق من جهة الاتصال المطلوبة',
    requiredText: 'يجب عليك تقديم رقم الهاتف أو عنوان البريد الإلكتروني للبحث عن الطرود',
    phoneNumber: 'رقم الهاتف',
    phonePlaceholder: 'أدخل رقم الهاتف المكون من 9 أرقام (612345678)...',
    emailAddress: 'عنوان البريد الإلكتروني',
    emailPlaceholder: 'أدخل بريدك الإلكتروني...',
    searchButton: 'ابحث عن طردي',
    searching: 'جاري البحث عن الطرود...',
    clearFields: 'مسح جميع الحقول',
    trustBadges: { secure: 'آمن', instant: 'فوري', verified: 'موثق' },
    packageReady: 'الطرد جاهز للاستلام!',
    packageWaiting: 'طردك في انتظارك في Ashop',
    boxNumberTitle: 'طردك في صندوق رقم',
    lookForBox: 'ابحث عن الصندوق بهذا الرقم!',
    packagesFound: 'طرود تم العثور عليها',
    trackingNumbers: 'أرقام التتبع',
    verified: 'موثق',
    scannable: 'قابل للمسح',
    scannableBarcode: 'الباركود القابل للمسح',
    compatibleBarcode: 'الباركود المتوافق',
    showBarcode: 'اعرض هذا الباركود للموظفين للمسح السريع',
    carrier: 'الناقل',
    received: 'تم الاستلام',
    pickedUp: 'تم الاستلام',
    alreadyPickedUp: 'تم الاستلام بالفعل',
    confirmPickup: 'تأكيد الاستلام',
    note: 'ملاحظة',
    noPackagesFound: 'لم يتم العثور على طرود',
    checkSpelling: 'يرجى التحقق من تهجئة اسمك أو جرب رقم صندوقك',
    securityNotice: 'إشعار أمني',
    securityMessage: 'يرجى تقديم رقم هاتفك (9 أرقام، تنسيق هولندا) أو عنوان بريدك الإلكتروني للتحقق قبل البحث عن الطرود.',
    securityHelp: 'يساعدنا هذا على ضمان أمان الطرود ويمنع الوصول غير المصرح به.',
    understand: 'فهمت',
    informationSecure: 'معلوماتك آمنة ومحمية',
    enterPinToUnlock: 'أدخل رمز PIN لفتح القفل',
    enterPinPrompt: 'يرجى إدخال رمز PIN المكون من 4 أرقام لفتح الصفحة',
    enterPin: 'أدخل رمز PIN',
    incorrectPin: 'رمز PIN غير صحيح. يرجى المحاولة مرة أخرى.',
    cancel: 'إلغاء',
    unlock: 'فتح القفل',
  },
  nl: {
    code: 'nl',
    name: 'Nederlands',
    flag: '🇳🇱',
    dir: 'ltr',
    backButton: 'Terug',
    lockPage: 'Pagina vergrendelen',
    locked: 'Vergrendeld',
    findYour: 'Vind uw',
    package: 'Pakket',
    subtitle: 'Veilige pakketophaaldienst • Professioneel pakketbeheer voor onze lokale gemeenschap',
    businessInfo: 'Ashop Lokale Bedrijfspakketdienst',
    searchInstructions: 'Zoek uw pakket met onderstaande informatie',
    firstName: 'Voornaam',
    firstNamePlaceholder: 'Voer uw voornaam in...',
    lastName: 'Achternaam',
    lastNamePlaceholder: 'Voer uw achternaam in...',
    orDivider: 'OF',
    trackingNumber: 'Trackingnummer',
    trackingPlaceholder: 'Voer trackingnummer in...',
    requiredVerification: 'Verplichte contactverificatie',
    requiredText: 'U MOET een telefoonnummer OF e-mailadres opgeven om pakketten te zoeken',
    phoneNumber: 'Telefoonnummer',
    phonePlaceholder: 'Voer 9-10 cijferig nummer in...',
    emailAddress: 'E-mailadres',
    emailPlaceholder: 'Voer uw e-mail in...',
    searchButton: 'Vind Mijn Pakket',
    searching: 'Pakketten zoeken...',
    clearFields: 'Alle velden wissen',
    trustBadges: { secure: 'Veilig', instant: 'Direct', verified: 'Geverifieerd' },
    packageReady: 'Pakket klaar om op te halen!',
    packageWaiting: 'Uw pakket wacht op u bij Ashop',
    boxNumberTitle: 'Uw pakket zit in doos nummer',
    lookForBox: 'Zoek naar de doos met dit nummer!',
    packagesFound: 'Pakketten gevonden',
    trackingNumbers: 'Trackingnummers',
    verified: 'GEVERIFIEERD',
    scannable: 'SCANBAAR',
    scannableBarcode: 'Scanbare barcode',
    compatibleBarcode: 'Compatibele barcode',
    showBarcode: 'Toon deze barcode aan personeel voor snel scannen',
    carrier: 'Vervoerder',
    received: 'Ontvangen',
    pickedUp: 'Opgehaald',
    alreadyPickedUp: 'Reeds opgehaald',
    confirmPickup: 'Ophalen bevestigen',
    note: 'Opmerking',
    noPackagesFound: 'Geen pakketten gevonden',
    checkSpelling: 'Controleer uw naamspelling of probeer uw doornummer',
    securityNotice: 'Beveiligingsmelding',
    securityMessage: 'Geef uw telefoonnummer (9 cijfers, Nederlands formaat) OF e-mailadres op voor verificatie voordat u naar pakketten zoekt.',
    securityHelp: 'Dit helpt ons de veiligheid van pakketten te waarborgen en voorkomt ongeoorloofde toegang.',
    understand: 'Begrepen',
    informationSecure: 'Uw informatie is veilig en beschermd',
    enterPinToUnlock: 'Voer PIN in om te ontgrendelen',
    enterPinPrompt: 'Voer de 4-cijferige PIN in om de pagina te ontgrendelen',
    enterPin: 'Voer PIN in',
    incorrectPin: 'Onjuiste PIN. Probeer het opnieuw.',
    cancel: 'Annuleren',
    unlock: 'Ontgrendelen',
  },
  fr: {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
    dir: 'ltr',
    backButton: 'Retour',
    lockPage: 'Verrouiller la page',
    locked: 'Verrouillé',
    findYour: 'Trouvez votre',
    package: 'Colis',
    subtitle: 'Service de retrait sécurisé de colis • Gestion professionnelle de colis pour notre communauté locale',
    businessInfo: 'Service de colis commercial local Ashop',
    searchInstructions: 'Recherchez votre colis en utilisant les informations ci-dessous',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Entrez votre prénom...',
    lastName: 'Nom de famille',
    lastNamePlaceholder: 'Entrez votre nom de famille...',
    orDivider: 'OU',
    trackingNumber: 'Numéro de suivi',
    trackingPlaceholder: 'Entrez le numéro de suivi...',
    requiredVerification: 'Vérification de contact requise',
    requiredText: 'Vous DEVEZ fournir un numéro de téléphone OU une adresse e-mail pour rechercher des colis',
    phoneNumber: 'Numéro de téléphone',
    phonePlaceholder: 'Entrez un numéro à 9 chiffres (612345678)...',
    emailAddress: 'Adresse e-mail',
    emailPlaceholder: 'Entrez votre e-mail...',
    searchButton: 'Trouver mon colis',
    searching: 'Recherche de colis...',
    clearFields: 'Effacer tous les champs',
    trustBadges: { secure: 'Sécurisé', instant: 'Instantané', verified: 'Vérifié' },
    packageReady: 'Colis prêt à être retiré !',
    packageWaiting: 'Votre colis vous attend chez Ashop',
    boxNumberTitle: 'Votre colis est dans la boîte numéro',
    lookForBox: 'Cherchez la boîte avec ce numéro !',
    packagesFound: 'Colis trouvés',
    trackingNumbers: 'Numéros de suivi',
    verified: 'VÉRIFIÉ',
    scannable: 'SCANNABLE',
    scannableBarcode: 'Code-barres scannable',
    compatibleBarcode: 'Code-barres compatible',
    showBarcode: 'Montrez ce code-barres au personnel pour un scan rapide',
    carrier: 'Transporteur',
    received: 'Reçu',
    pickedUp: 'Retiré',
    alreadyPickedUp: 'Déjà retiré',
    confirmPickup: 'Confirmer le retrait',
    note: 'Remarque',
    noPackagesFound: 'Aucun colis trouvé',
    checkSpelling: 'Veuillez vérifier l\'orthographe de votre nom ou essayez votre numéro de boîte',
    securityNotice: 'Avis de sécurité',
    securityMessage: 'Veuillez fournir votre numéro de téléphone (9 chiffres, format néerlandais) OU votre adresse e-mail pour vérification avant de rechercher des colis.',
    securityHelp: 'Cela nous aide à assurer la sécurité des colis et à prévenir les accès non autorisés.',
    understand: 'Compris',
    informationSecure: 'Vos informations sont sécurisées et protégées',
    enterPinToUnlock: 'Entrez le code PIN pour déverrouiller',
    enterPinPrompt: 'Veuillez entrer le code PIN à 4 chiffres pour déverrouiller la page',
    enterPin: 'Entrez le code PIN',
    incorrectPin: 'Code PIN incorrect. Veuillez réessayer.',
    cancel: 'Annuler',
    unlock: 'Déverrouiller',
  },
  de: {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪',
    dir: 'ltr',
    backButton: 'Zurück',
    lockPage: 'Seite sperren',
    locked: 'Gesperrt',
    findYour: 'Finden Sie Ihr',
    package: 'Paket',
    subtitle: 'Sicherer Paketabholservice • Professionelle Paketverwaltung für unsere lokale Gemeinschaft',
    businessInfo: 'Ashop Lokaler Geschäftspaketdienst',
    searchInstructions: 'Suchen Sie Ihr Paket mit den folgenden Informationen',
    firstName: 'Vorname',
    firstNamePlaceholder: 'Geben Sie Ihren Vornamen ein...',
    lastName: 'Nachname',
    lastNamePlaceholder: 'Geben Sie Ihren Nachnamen ein...',
    orDivider: 'ODER',
    trackingNumber: 'Sendungsnummer',
    trackingPlaceholder: 'Sendungsnummer eingeben...',
    requiredVerification: 'Erforderliche Kontaktverifizierung',
    requiredText: 'Sie MÜSSEN eine Telefonnummer ODER E-Mail-Adresse angeben, um nach Paketen zu suchen',
    phoneNumber: 'Telefonnummer',
    phonePlaceholder: '9-stellige Nummer eingeben (612345678)...',
    emailAddress: 'E-Mail-Adresse',
    emailPlaceholder: 'Geben Sie Ihre E-Mail ein...',
    searchButton: 'Mein Paket finden',
    searching: 'Pakete werden gesucht...',
    clearFields: 'Alle Felder löschen',
    trustBadges: { secure: 'Sicher', instant: 'Sofort', verified: 'Verifiziert' },
    packageReady: 'Paket zur Abholung bereit!',
    packageWaiting: 'Ihr Paket wartet bei Ashop auf Sie',
    boxNumberTitle: 'Ihr Paket ist in Box Nummer',
    lookForBox: 'Suchen Sie nach der Box mit dieser Nummer!',
    packagesFound: 'Pakete gefunden',
    trackingNumbers: 'Sendungsnummern',
    verified: 'VERIFIZIERT',
    scannable: 'SCANBAR',
    scannableBarcode: 'Scanbarer Barcode',
    compatibleBarcode: 'Kompatibler Barcode',
    showBarcode: 'Zeigen Sie diesen Barcode dem Personal zum schnellen Scannen',
    carrier: 'Spediteur',
    received: 'Empfangen',
    pickedUp: 'Abgeholt',
    alreadyPickedUp: 'Bereits abgeholt',
    confirmPickup: 'Abholung bestätigen',
    note: 'Hinweis',
    noPackagesFound: 'Keine Pakete gefunden',
    checkSpelling: 'Bitte überprüfen Sie die Schreibweise Ihres Namens oder versuchen Sie Ihre Boxnummer',
    securityNotice: 'Sicherheitshinweis',
    securityMessage: 'Bitte geben Sie Ihre Telefonnummer (9 Ziffern, niederländisches Format) ODER E-Mail-Adresse zur Verifizierung an, bevor Sie nach Paketen suchen.',
    securityHelp: 'Dies hilft uns, die Paketsicherheit zu gewährleisten und unbefugten Zugriff zu verhindern.',
    understand: 'Verstanden',
    informationSecure: 'Ihre Informationen sind sicher und geschützt',
    enterPinToUnlock: 'PIN eingeben zum Entsperren',
    enterPinPrompt: 'Bitte geben Sie die 4-stellige PIN ein, um die Seite zu entsperren',
    enterPin: 'PIN eingeben',
    incorrectPin: 'Falsche PIN. Bitte versuchen Sie es erneut.',
    cancel: 'Abbrechen',
    unlock: 'Entsperren',
  },
  it: {
    code: 'it',
    name: 'Italiano',
    flag: '🇮🇹',
    dir: 'ltr',
    backButton: 'Indietro',
    lockPage: 'Blocca pagina',
    locked: 'Bloccato',
    findYour: 'Trova il tuo',
    package: 'Pacco',
    subtitle: 'Servizio di ritiro pacchi sicuro • Gestione professionale dei pacchi per la nostra comunità locale',
    businessInfo: 'Servizio pacchi commerciale locale Ashop',
    searchInstructions: 'Cerca il tuo pacco utilizzando le informazioni di seguito',
    firstName: 'Nome',
    firstNamePlaceholder: 'Inserisci il tuo nome...',
    lastName: 'Cognome',
    lastNamePlaceholder: 'Inserisci il tuo cognome...',
    orDivider: 'O',
    trackingNumber: 'Numero di tracciamento',
    trackingPlaceholder: 'Inserisci il numero di tracciamento...',
    requiredVerification: 'Verifica del contatto richiesta',
    requiredText: 'DEVI fornire un numero di telefono O un indirizzo email per cercare i pacchi',
    phoneNumber: 'Numero di telefono',
    phonePlaceholder: 'Inserisci numero a 9 cifre (612345678)...',
    emailAddress: 'Indirizzo email',
    emailPlaceholder: 'Inserisci la tua email...',
    searchButton: 'Trova il mio pacco',
    searching: 'Ricerca pacchi...',
    clearFields: 'Cancella tutti i campi',
    trustBadges: { secure: 'Sicuro', instant: 'Istantaneo', verified: 'Verificato' },
    packageReady: 'Pacco pronto per il ritiro!',
    packageWaiting: 'Il tuo pacco ti aspetta da Ashop',
    boxNumberTitle: 'Il tuo pacco è nella scatola numero',
    lookForBox: 'Cerca la scatola con questo numero!',
    packagesFound: 'Pacchi trovati',
    trackingNumbers: 'Numeri di tracciamento',
    verified: 'VERIFICATO',
    scannable: 'SCANSIONABILE',
    scannableBarcode: 'Codice a barre scansionabile',
    compatibleBarcode: 'Codice a barre compatibile',
    showBarcode: 'Mostra questo codice a barre al personale per una scansione rapida',
    carrier: 'Corriere',
    received: 'Ricevuto',
    pickedUp: 'Ritirato',
    alreadyPickedUp: 'Già ritirato',
    confirmPickup: 'Conferma ritiro',
    note: 'Nota',
    noPackagesFound: 'Nessun pacco trovato',
    checkSpelling: 'Controlla l\'ortografia del tuo nome o prova il numero della tua scatola',
    securityNotice: 'Avviso di sicurezza',
    securityMessage: 'Fornisci il tuo numero di telefono (9 cifre, formato olandese) O indirizzo email per la verifica prima di cercare i pacchi.',
    securityHelp: 'Questo ci aiuta a garantire la sicurezza dei pacchi e prevenire accessi non autorizzati.',
    understand: 'Capito',
    informationSecure: 'Le tue informazioni sono sicure e protette',
    enterPinToUnlock: 'Inserisci PIN per sbloccare',
    enterPinPrompt: 'Inserisci il PIN a 4 cifre per sbloccare la pagina',
    enterPin: 'Inserisci PIN',
    incorrectPin: 'PIN errato. Riprova.',
    cancel: 'Annulla',
    unlock: 'Sblocca',
  },
  ur: {
    code: 'ur',
    name: 'اردو',
    flag: '🇵🇰',
    dir: 'rtl',
    backButton: 'واپس',
    lockPage: 'صفحہ مقفل کریں',
    locked: 'مقفل',
    findYour: 'اپنا تلاش کریں',
    package: 'پیکیج',
    subtitle: 'محفوظ پیکیج وصولی کی خدمت • ہماری مقامی کمیونٹی کے لیے پیشہ ورانہ پیکیج کا انتظام',
    businessInfo: 'Ashop مقامی کاروباری پیکیج سروس',
    searchInstructions: 'ذیل کی معلومات استعمال کرکے اپنا پیکیج تلاش کریں',
    firstName: 'پہلا نام',
    firstNamePlaceholder: 'اپنا پہلا نام درج کریں...',
    lastName: 'آخری نام',
    lastNamePlaceholder: 'اپنا آخری نام درج کریں...',
    orDivider: 'یا',
    trackingNumber: 'ٹریکنگ نمبر',
    trackingPlaceholder: 'ٹریکنگ نمبر درج کریں...',
    requiredVerification: 'رابطہ کی تصدیق ضروری ہے',
    requiredText: 'آپ کو پیکیج تلاش کرنے کے لیے فون نمبر یا ای میل ایڈریس فراہم کرنا ضروری ہے',
    phoneNumber: 'فون نمبر',
    phonePlaceholder: '9 ہندسوں کا نمبر درج کریں (612345678)...',
    emailAddress: 'ای میل ایڈریس',
    emailPlaceholder: 'اپنا ای میل درج کریں...',
    searchButton: 'میرا پیکیج تلاش کریں',
    searching: 'پیکیج تلاش کیا جا رہا ہے...',
    clearFields: 'تمام فیلڈز صاف کریں',
    trustBadges: { secure: 'محفوظ', instant: 'فوری', verified: 'تصدیق شدہ' },
    packageReady: 'پیکیج وصول کرنے کے لیے تیار ہے!',
    packageWaiting: 'آپ کا پیکیج Ashop میں آپ کا منتظر ہے',
    boxNumberTitle: 'آپ کا پیکیج باکس نمبر میں ہے',
    lookForBox: 'اس نمبر والا باکس تلاش کریں!',
    packagesFound: 'پیکیج ملے',
    trackingNumbers: 'ٹریکنگ نمبرز',
    verified: 'تصدیق شدہ',
    scannable: 'اسکین کے قابل',
    scannableBarcode: 'اسکین کے قابل بارکوڈ',
    compatibleBarcode: 'مطابقت پذیر بارکوڈ',
    showBarcode: 'تیز اسکیننگ کے لیے یہ بارکوڈ عملے کو دکھائیں',
    carrier: 'کیریئر',
    received: 'موصول ہوا',
    pickedUp: 'وصول کیا',
    alreadyPickedUp: 'پہلے ہی وصول کیا جا چکا',
    confirmPickup: 'وصولی کی تصدیق کریں',
    note: 'نوٹ',
    noPackagesFound: 'کوئی پیکیج نہیں ملا',
    checkSpelling: 'براہ کرم اپنے نام کی ہجے چیک کریں یا اپنا باکس نمبر آزمائیں',
    securityNotice: 'سیکیورٹی نوٹس',
    securityMessage: 'پیکیج تلاش کرنے سے پہلے تصدیق کے لیے اپنا فون نمبر (9 ہندسے، نیدرلینڈز فارمیٹ) یا ای میل ایڈریس فراہم کریں۔',
    securityHelp: 'یہ ہمیں پیکیج کی حفاظت کو یقینی بنانے اور غیر مجاز رسائی کو روکنے میں مدد کرتا ہے۔',
    understand: 'سمجھ گیا',
    informationSecure: 'آپ کی معلومات محفوظ اور محفوظ ہیں',
    enterPinToUnlock: 'کھولنے کے لیے PIN درج کریں',
    enterPinPrompt: 'صفحہ کھولنے کے لیے 4 ہندسوں کا PIN درج کریں',
    enterPin: 'PIN درج کریں',
    incorrectPin: 'غلط PIN۔ براہ کرم دوبارہ کوشش کریں۔',
    cancel: 'منسوخ کریں',
    unlock: 'کھولیں',
  },
  hi: {
    code: 'hi',
    name: 'हिन्दी',
    flag: '🇮🇳',
    dir: 'ltr',
    backButton: 'वापस',
    lockPage: 'पेज लॉक करें',
    locked: 'लॉक किया हुआ',
    findYour: 'अपना खोजें',
    package: 'पैकेज',
    subtitle: 'सुरक्षित पैकेज पिकअप सेवा • हमारे स्थानीय समुदाय के लिए पेशेवर पैकेज प्रबंधन',
    businessInfo: 'Ashop स्थानीय व्यवसाय पैकेज सेवा',
    searchInstructions: 'नीचे दी गई जानकारी का उपयोग करके अपना पैकेज खोजें',
    firstName: 'पहला नाम',
    firstNamePlaceholder: 'अपना पहला नाम दर्ज करें...',
    lastName: 'अंतिम नाम',
    lastNamePlaceholder: 'अपना अंतिम नाम दर्ज करें...',
    orDivider: 'या',
    trackingNumber: 'ट्रैकिंग नंबर',
    trackingPlaceholder: 'ट्रैकिंग नंबर दर्ज करें...',
    requiredVerification: 'संपर्क सत्यापन आवश्यक',
    requiredText: 'पैकेज खोजने के लिए आपको फोन नंबर या ईमेल पता प्रदान करना आवश्यक है',
    phoneNumber: 'फोन नंबर',
    phonePlaceholder: '9 अंकों का नंबर दर्ज करें (612345678)...',
    emailAddress: 'ईमेल पता',
    emailPlaceholder: 'अपना ईमेल दर्ज करें...',
    searchButton: 'मेरा पैकेज खोजें',
    searching: 'पैकेज खोजे जा रहे हैं...',
    clearFields: 'सभी फ़ील्ड साफ़ करें',
    trustBadges: { secure: 'सुरक्षित', instant: 'तत्काल', verified: 'सत्यापित' },
    packageReady: 'पैकेज पिकअप के लिए तैयार है!',
    packageWaiting: 'आपका पैकेज Ashop में आपकी प्रतीक्षा कर रहा है',
    boxNumberTitle: 'आपका पैकेज बॉक्स नंबर में है',
    lookForBox: 'इस नंबर वाला बॉक्स खोजें!',
    packagesFound: 'पैकेज मिले',
    trackingNumbers: 'ट्रैकिंग नंबर',
    verified: 'सत्यापित',
    scannable: 'स्कैन करने योग्य',
    scannableBarcode: 'स्कैन करने योग्य बारकोड',
    compatibleBarcode: 'संगत बारकोड',
    showBarcode: 'त्वरित स्कैनिंग के लिए यह बारकोड स्टाफ को दिखाएं',
    carrier: 'वाहक',
    received: 'प्राप्त हुआ',
    pickedUp: 'उठाया गया',
    alreadyPickedUp: 'पहले ही उठाया जा चुका',
    confirmPickup: 'पिकअप की पुष्टि करें',
    note: 'नोट',
    noPackagesFound: 'कोई पैकेज नहीं मिला',
    checkSpelling: 'कृपया अपने नाम की वर्तनी जांचें या अपना बॉक्स नंबर आजमाएं',
    securityNotice: 'सुरक्षा सूचना',
    securityMessage: 'पैकेज खोजने से पहले सत्यापन के लिए कृपया अपना फोन नंबर (9 अंक, नीदरलैंड प्रारूप) या ईमेल पता प्रदान करें।',
    securityHelp: 'यह हमें पैकेज सुरक्षा सुनिश्चित करने और अनधिकृत पहुंच को रोकने में मदद करता है।',
    understand: 'समझ गया',
    informationSecure: 'आपकी जानकारी सुरक्षित और संरक्षित है',
    enterPinToUnlock: 'अनलॉक करने के लिए PIN दर्ज करें',
    enterPinPrompt: 'पेज को अनलॉक करने के लिए 4 अंकों का PIN दर्ज करें',
    enterPin: 'PIN दर्ज करें',
    incorrectPin: 'गलत PIN। कृपया पुन: प्रयास करें।',
    cancel: 'रद्द करें',
    unlock: 'अनलॉक करें',
  },
};

export default translations;
